import React, { FC, forwardRef } from 'react';
import s from './GeneratedImage.module.css';
import add_photo from '../../../../assets/img/add_photo_alternate.svg';
import { CurrentProject } from '../../../../shared/types/projectTypes';
import { getImageDimensions } from '../../../../shared/helpers/getImageDimensions';
import IconAdd from '../../../../shared/ui/icons/IconAdd';
import { useAppDispatch } from '../../../../store/store';
import { createImageProject } from '../../../../shared/api/imageProjectApi';
import { useNavigate } from 'react-router-dom';
interface GeneratedImageProps {
    imageUrl: string | null;
    imageId: string | null;
    currentProject: CurrentProject;
    isFocused: boolean;
}

const GeneratedImage = forwardRef<HTMLDivElement, GeneratedImageProps>(
    ({ imageUrl, currentProject, isFocused, imageId }, ref) => {
        const dispatch = useAppDispatch();
        const dimensions = getImageDimensions(currentProject.content_type);
        const aspectRatio = (dimensions.height / dimensions.width) * 100;
        const navigate = useNavigate();

        const containerClass =
            currentProject.content_type.toLowerCase() === 'instagram'
                ? s.container_instagram
                : s.container;

        const handleCreateImageProject = async () => {
            if (imageId) {
                return;
            }
            try {
                const newProject = await dispatch(
                    createImageProject({
                        title: currentProject.title,
                        slideshow: {
                            enabled: false,
                            count: 1,
                        },
                        projectId: currentProject.id,
                    }),
                ).unwrap();

                if (newProject?.id) {
                    navigate(`/image_project/${newProject.id}`);
                } else {
                    console.error('No ID returned from createImageProject');
                }
            } catch (err) {
                console.error('Error creating project:', err);
            }
        };
        return (
            <div className={containerClass}>
                {imageUrl ? (
                    <div
                        ref={ref}
                        className={`${s.image_wrapper} ${isFocused ? s.focused : ''}`}
                        style={{
                            position: 'relative',
                            width: '100%',
                            paddingBottom: `${aspectRatio}%`,
                        }}
                    >
                        <img
                            src={imageUrl}
                            alt="Uploaded"
                            className={s.image}
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                            }}
                        />
                    </div>
                ) : (
                    <div
                        className={s.empty_container}
                        onClick={handleCreateImageProject}
                        ref={ref}
                        style={{
                            position: 'relative',
                            width: '100%',
                            paddingBottom: `${aspectRatio}%`,
                        }}
                    >
                        <div className={s.add_icon_container}>
                            <IconAdd />
                        </div>
                    </div>
                )}
            </div>
        );
    },
);

export default GeneratedImage;
